import React, { useState, useEffect } from "react";
import axios from "axios";

import "./NewsLetterTitle.css";

const NewsLetterTitle =(props) =>{
  const [items,setItems] = useState([]);
  useEffect(()=>{
  },[]);
  let renderitems= props.items.map((item,index)=>{
          if(!!item.MashanIsActive){
                        return <div  key={index} className="newslettertitle-title-text col-12 col-md-8">
                                  {item.ContainerTitle}
                                  <div className="newslettertitle-text" dangerouslySetInnerHTML={{__html:item.RichTextContainer}}></div>           
                                </div>
          } });
                
    return (
          <div className="container-newsletter-wrapper row" >
                {renderitems}
          </div>
    )
}

export default NewsLetterTitle;